/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc, SCS */

	/**
	 * Page module implementation.
	 *
	 * @author Bozo Jovicic
	 * @namespace Tc.Module
	 * @class Twitter
	 * @extends Tc.Module
	 */

	Tc.Module.Twitter = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			callback();
		},

		after : function() {
			var mod = this;

			var tweetId = mod.$ctx.data('tweet-id');
			if(tweetId){
				var url = 'https://api.twitter.com/1/statuses/oembed.json?id=' + tweetId;
				var width = mod.$ctx.data('width');
				if(width){
					url += '&maxwidth=' + width;
				}

				$.getJSON(url + "&callback=?", null, function(res) {
					if(res && typeof(res.html) != "undefined") {
						mod.$ctx.find('.tweet').html(res.html);

						var tweetUrl = null;
						var resHtmlArray = res.html.split('\"');
						for (var i=0;i < resHtmlArray.length; i+=1) {
							if(resHtmlArray[i].indexOf('https://twitter.com/') > -1){
								tweetUrl = resHtmlArray[i];
							}
						}
						mod.$ctx.find('.tweet').closest('.image-post').data('url', tweetUrl);
					}
				});
			}
		}
	});

}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.Twitter.js
// module id = 330
// module chunks = 0